import { ActionType } from '@wix/ambassador-devcenter-site-apps-v1-app/types';
export const WIX_APP_MARKET_TERMS_AND_CONDITIONS = `https://www.wix.com/about/app-market-terms`;
export const APP_INSTALLER_REFERRAL_INFO = 'app-installer';
export const connectDomainLink = tenantId => `https://www.wix.com/dashboard/${tenantId}/manage-website/domains?referralInfo=${APP_INSTALLER_REFERRAL_INFO}`;
export const upgradeSiteLink = tenantId => `https://premium.wix.com/wix/api/premiumStart?siteGuid=${tenantId}&referralAdditionalInfo=${APP_INSTALLER_REFERRAL_INFO}`;
export const LOGIN_LINK = 'https://users.wix.com/signin';
const manageAppsExtensionId = 'ad471122-7305-4007-9210-2a764d2e5e57';
export const getManageAppsRequiredAction = tenantId => ({
  actionType: ActionType.DASHBOARD,
  link: getManageAppsUrl(tenantId),
  postInstallationComponentId: manageAppsExtensionId
});
export const getManageAppsUrl = tenantId => `https://www.wix.com/dashboard/${tenantId}/manage-installed-apps?referralInfo=app-installer`;
export const ADD_COLLABORATORS_URL = 'https://support.wix.com/en/article/roles-permissions-changing-a-collaborators-role';
export const WIX_STATUS_PAGE_LINK = 'https://status.wix.com/';
export const TEST_YOUR_APP_DOC = 'https://dev.wix.com/docs/build-apps/launch-your-app/app-distribution/test-your-app-on-a-premium-site';
export const EDITOR_DOC = 'https://support.wix.com/en/article/wix-editor-getting-started-with-the-wix-editor';
export const STUDIO_EDITOR_DOC = 'https://support.wix.com/en/article/studio-editor-a-guided-tour';
//# sourceMappingURL=consts.js.map